/** Status labels are tied to the durable record that permits them to be
 * shown. A computed or held result is not evidence that a person reviewed it. */
export const STATUS_WORDS = {
  held_for_release: {
    event: 'results_held',
    title: 'Your results are held for release.',
    body: "We'll email you when they're ready.",
  },
  released: {
    event: 'results_released',
    also: 'results_auto_released',
    title: 'Your results are ready.',
  },
  sent_to_counsel: {
    event: 'promoted',
    title: 'Your report was sent for compliance review.',
  },
  in_counsel_review: {
    event: 'counsel_opened',
    title: 'Your report is in compliance review.',
  },
  reviewed: {
    event: 'round_completed',
    title: 'A compliance review round was recorded.',
  },
  round_signed_off: {
    event: 'round_completed',
    condition: "completion_outcome = 'signed_off'",
    title: "This report's review round was signed off",
  },
  round_changes_requested: {
    event: 'round_completed',
    condition: "completion_outcome = 'changes_requested'",
    title: 'Counsel asked for changes to this report.',
  },
  signed_off: {
    event: 'sign_deliverable',
    title: 'The report was signed off.',
  },
} as const;

export const HELD_WORDS = {
  title: STATUS_WORDS.held_for_release.title,
  body: STATUS_WORDS.held_for_release.body,
} as const;

export const HELD_SENTENCE = `${HELD_WORDS.title} ${HELD_WORDS.body}`;

/** The held card's only action, when something is still needed. */
export const HELD_ACTION = "See what's still needed";

/** A newer held check does not withdraw the previously released result. */
export const HELD_UPDATE_SENTENCE = "Your newest results are with our team. Your released report is still available.";
